import React from 'react';
import JavascriptVersions from './JavascriptVersions.jsx';
import JavascriptVersionsEs5 from './JavascriptVersionsEs5.jsx';
import JavascriptVersionsEs6 from './JavascriptVersionsEs6.jsx';
import JavascriptVersions2016 from './JavascriptVersions2016.jsx';
import JavascriptVersions2017 from './JavascriptVersions2017.jsx';
import JavascriptVersions2018 from './JavascriptVersions2018.jsx';
import JavascriptVersions2019 from './JavascriptVersions2019.jsx';
import JavascriptVersions2020 from './JavascriptVersions2020.jsx';
import JavascriptVersions2021 from './JavascriptVersions2021.jsx';
import JavascriptVersions2022 from './JavascriptVersions2022.jsx';
import JavascriptVersions2023 from './JavascriptVersions2023.jsx';
import JavascriptVersions2024 from './JavascriptVersions2024.jsx';
import JavascriptVersions2025 from './JavascriptVersions2025.jsx';
import JavascriptVersionsIeEdge from './JavascriptVersionsIeEdge.jsx';
import JavascriptVersionsHistory from './JavascriptVersionsHistory.jsx';

export default function JsVersions() {
  return (
    <div className="p-6 max-w-4xl mx-auto">
      <h1 className="text-3xl font-bold">JS Versions</h1>
      <ul className="mt-4 list-disc ml-6">
        <li><a href='/javascript/versions' className='underline'>JS Versions</a></li>
<li><a href='/javascript/versions/es5' className='underline'>JS 2009 (ES5)</a></li>
<li><a href='/javascript/versions/es6' className='underline'>JS 2015 (ES6)</a></li>
<li><a href='/javascript/versions/2016' className='underline'>JS 2016</a></li>
<li><a href='/javascript/versions/2017' className='underline'>JS 2017</a></li>
<li><a href='/javascript/versions/2018' className='underline'>JS 2018</a></li>
<li><a href='/javascript/versions/2019' className='underline'>JS 2019</a></li>
<li><a href='/javascript/versions/2020' className='underline'>JS 2020</a></li>
<li><a href='/javascript/versions/2021' className='underline'>JS 2021</a></li>
<li><a href='/javascript/versions/2022' className='underline'>JS 2022</a></li>
<li><a href='/javascript/versions/2023' className='underline'>JS 2023</a></li>
<li><a href='/javascript/versions/2024' className='underline'>JS 2024</a></li>
<li><a href='/javascript/versions/2025' className='underline'>JS 2025</a></li>
<li><a href='/javascript/versions/ie-edge' className='underline'>JS IE / Edge</a></li>
<li><a href='/javascript/versions/history' className='underline'>JS History</a></li>
      </ul>
    </div>
  );
}
